import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

/** Row from api/AdminUser/GetAll. */
export interface AdminUserRow {
  userId: number;
  username: string;
  email: string;
  mobileNo: string;
  isVerified: boolean;
  status: boolean;
  createdDate: string;
  roles?: string | null;
  /** Set when the login was created through partner onboarding. */
  partnerName?: string | null;
}

export interface CreateAdminUserRequest {
  username: string;
  email: string;
  mobileNo: string;
  password: string;
  /** The code the new admin received on their mobile (AdminUser/SendOtp). */
  otp: string;
}

/** Admin login-account management (standalone admin logins, no partner behind them). */
@Injectable({ providedIn: 'root' })
export class AdminUserService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/AdminUser`;

  getAll() {
    return this.http.get(`${this.baseUrl}/GetAll`);
  }

  /** OTP to the NEW admin's mobile; Create must carry the code back. */
  sendOtp(mobileNo: string) {
    return this.http.post(`${this.baseUrl}/SendOtp`, { mobileNo });
  }

  create(body: CreateAdminUserRequest) {
    return this.http.post(`${this.baseUrl}/Create`, body);
  }

  resetPassword(userId: number, newPassword: string) {
    return this.http.post(`${this.baseUrl}/ResetPassword`, { userId, newPassword });
  }

  enable(id: number) {
    return this.http.get(`${this.baseUrl}/Enable`, { params: { id } });
  }

  disable(id: number) {
    return this.http.get(`${this.baseUrl}/Disable`, { params: { id } });
  }
}
